import React from 'react';
import { useBarcode } from '@createnextapp/react-barcode';

function Bargenerator() {
  const { inputRef } = useBarcode({
    value: 'BTI-D12-00688',
    options: {
      background: '#ffffff',
    }
  });

  return <img ref={inputRef} />;
};

export default Bargenerator;